import styled from 'styled-components'

export const ContainerAtom = styled.div<{ $padding?: string }>`
  padding: ${({ $padding }) => $padding};
`
